import { API_BASE_URL } from '../../env';
import { ApiReturnType } from '../../interfaces/api/api';
import { toQueryParamsString } from '../../utils/ApiUtils';

const LEGACY_DEAL_FIELDS =
  'id, name, dateCreate, lost, type{id, name}, interlocutors{name, lastname, email, id}, customer{ id, installationSite{socialReason, adress, postalCode, telOffice}}';

export default {
  get: (id: string): ApiReturnType => ({
    endpoint: `${API_BASE_URL}/v2/deal/deals/${id}`,
    headers: { 'Content-Type': 'application/json' },
    method: 'GET',
  }),
  getDeliveryOrderToken: (id: number, providerId: string): ApiReturnType => ({
    endpoint: `${API_BASE_URL}/api/deal/${id}/generate-delivery-order-token?providerId=${providerId}`,
    headers: { 'Content-Type': 'application/json' },
    method: 'GET',
  }),
  getInterventionOrderToken: (id: number): ApiReturnType => ({
    endpoint: `${API_BASE_URL}/api/deal/${id}/generate-intervention-order-token`,
    headers: { 'Content-Type': 'application/json' },
    method: 'GET',
  }),
  getLegacy: (id: number, additionnalFields = ''): ApiReturnType => {
    const fields = additionnalFields.length > 0 ? ',' + additionnalFields : '';

    return {
      endpoint: `${API_BASE_URL}/api/deal/show/{ deal(id:${id}){${LEGACY_DEAL_FIELDS}${fields}}`,
      headers: { 'Content-Type': 'application/json' },
      method: 'GET',
    };
  },
  getEmployeeDealAverageRatings: (dateStart?: string, dateEnd?: string): ApiReturnType => ({
    endpoint: `${API_BASE_URL}/api/deal/employees-average-ratings${toQueryParamsString({ dateStart, dateEnd })}`,
    headers: { 'Content-Type': 'application/json' },
    method: 'GET',
  }),
  search: (
    criteria: Record<string, unknown>,
    page: number,
    limit: number,
    orderBy: string,
    order: 'asc' | 'desc'
  ): ApiReturnType => {
    const criteriaString = Object.keys(criteria)
      .map((key) => `${key}:${criteria[key]}`)
      .join(',');

    return {
      endpoint: `${API_BASE_URL}/api/deal/{ deals(${criteriaString}, orderBy:${orderBy}, ASC:${
        order === 'asc'
      }, offset:${page * limit}, limit:${limit}){items{id, name}, hasMore}}`,
      headers: { 'Content-Type': 'application/json' },
      method: 'GET',
    };
  },
};
